MarketReportsApp.Models.SelectedAgg = Backbone.Model.extend({
    url: function() {
        return '/api/reports/associations/aggs/' + MarketReportsApp.Variables.SelectedAgg
    }
});